module.exports = __webpack_public_path__ + "static/media/googlepay.37fe4f0c.png";